import * as React from 'react';
import { localize } from 'core/localization';
import QuestionTreeNode from '../QuestionTreeNode/QuestionTreeNode';
import QuestionTreeNodeSubmitOnce from '../QuestionTreeNode/QuestionTreeNodeSubmitOnce';
import SectionTreeNode from '../SectionTreeNode/SectionTreeNode';

type ExpandedTocPoolSectionProps = {
  activeQuestionId: string;
  navigateToQuestion: any;
  questionsForPool: any[];
  isExpanded: boolean;
  isCourseProgress: boolean;
  shouldSubmitAllQuestions: boolean;
  isAttemptSubmitted: boolean;
  answeredPoolQuestionsCount: number;
};

const navigateWithKeyEvent = (event: any, question: any, navigateToQuestion: any) => {
  if (event.key === 'Enter') {
    return navigateToQuestion(question.sectionId, question.id);
  }
  return false;
};

const getTabIndex = (isExpanded: boolean) => {
  if (isExpanded) {
    return 0;
  }
  return -1;
};

function ExpandedTocPoolItems({ props }: any) {
  const {
    activeQuestionId,
    navigateToQuestion,
    questionsForPool,
    isExpanded,
    shouldSubmitAllQuestions,
    isAttemptSubmitted
  } = props;
  return questionsForPool.map((question: any, questionIndex: any) =>
    shouldSubmitAllQuestions ? (
      <QuestionTreeNodeSubmitOnce
        role="menuitem"
        key={questionIndex}
        question={question}
        isActive={question.id === activeQuestionId}
        tabIndex={getTabIndex(isExpanded)}
        isAttemptSubmitted={isAttemptSubmitted}
        {...(question.id !== activeQuestionId && {
          onClick: () => navigateToQuestion(question.sectionId, question.id),
          onKeyDown: event => navigateWithKeyEvent(event, question, navigateToQuestion)
        })}
      />
    ) : (
      <QuestionTreeNode
        role="menuitem"
        key={questionIndex}
        question={question}
        isActive={question.id === activeQuestionId}
        tabIndex={getTabIndex(isExpanded)}
        {...(question.id !== activeQuestionId && {
          onClick: () => navigateToQuestion(question.sectionId, question.id),
          onKeyDown: event => navigateWithKeyEvent(event, question, navigateToQuestion)
        })}
      />
    )
  );
}

class ExpandedTocPoolSection extends React.Component<ExpandedTocPoolSectionProps> {
  render() {
    const {
      activeQuestionId,
      navigateToQuestion,
      questionsForPool,
      isExpanded,
      isCourseProgress,
      shouldSubmitAllQuestions,
      isAttemptSubmitted,
      answeredPoolQuestionsCount
    } = this.props;

    return (
      <SectionTreeNode
        poolTitle={localize('[questions - second variation]')}
        isActive={activeQuestionId ? true : false}
        questionsForPool={questionsForPool}
        isCourseProgress={isCourseProgress}
        answeredPoolQuestionsCount={answeredPoolQuestionsCount}
        shouldSubmitAllQuestions={shouldSubmitAllQuestions}
        tabIndex={0}
      >
        <ExpandedTocPoolItems
          props={{
            activeQuestionId,
            navigateToQuestion,
            questionsForPool,
            isExpanded,
            shouldSubmitAllQuestions,
            isAttemptSubmitted
          }}
        />
      </SectionTreeNode>
    );
  }
}

export default ExpandedTocPoolSection;
